const getSelectLangStyles = (isDark, isDrawerLayout = false) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		height: isDrawerLayout ? '100%' : 'auto',
		flex: isDrawerLayout ? 1 : undefined,
		minHeight: isDrawerLayout ? 0 : undefined,
		maxHeight: isDrawerLayout
			? 'min(88dvh, 100%)'
			: { md: 'min(78vh, 680px)' },
		overflow: 'hidden',
		bgcolor: isDark ? '#161616' : '#FFFFFF',
		color: isDark ? '#FFFFFF' : '#111111',
	},
	scrollArea: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		WebkitOverflowScrolling: 'touch',
		mx: 'auto',
		bgcolor: isDark ? '#161616' : '#FFFFFF',
		padding: '1rem 1rem 0.5rem 1rem',
		width: {
			xs: '100%',
			md: '560px',
		},
	},
	boxContainer: {
		mx: 'auto',
		bgcolor: isDark ? '#161616' : '#FFFFFF',
		mt: '0 !important',
		padding: '1rem 1rem 0.5rem 1rem',
		width: {
			xs: '100%',
			md: '560px',
		},
		flex: 1,
		minHeight: 0,
		maxHeight: { xs: 'min(55vh, 100%)', md: 'min(78vh, 680px)' },
		overflowY: 'auto',
		WebkitOverflowScrolling: 'touch',
	},
	bottomStack: {
		flexShrink: 0,
		width: '100%',
		bgcolor: isDark ? '#161616' : '#FFFFFF',
	},
	dialogHeading: {
		fontSize: '18px',
		fontWeight: 600,
		color: isDark ? '#FFFFFF' : '#111111',
		lineHeight: '150%',
	},
	dialogSubHeading: {
		fontSize: '14px',
		lineHeight: '150%',
		color: isDark ? '#B0B0B0' : '#6C6C6C',
		paddingBottom: '0.5rem',
	},
	proceedButtonBase: {
		fontSize: '1rem',
		fontWeight: 500,
		lineHeight: '24px',
		padding: '12px 16px',
		borderRadius: '8px',
		width: {
			xs: '100%',
			md: 'auto',
		},
		textTransform: 'none',
		boxShadow: 'none',
	},
	buttonContainer: {
		display: 'flex',
		flexShrink: 0,
		padding: '1rem',
		borderTop: isDark ? '1px solid #2D2D2D' : '1px solid #D9D9D9',
		backgroundColor: isDark ? '#161616' : '#FFFFFF',
		justifyContent: {
			xs: 'center',
			md: 'flex-end',
		},
	},
	closeIcon: {
		cursor: 'pointer',
		fontSize: '18px',
		fontWeight: 600,
		color: isDark ? '#FFFFFF' : '#1C1B1F',
		lineHeight: '150%',
	},
	selectLang: {
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexDirection: 'row-reverse',
		mr: 0,
		ml: 0,
		borderRadius: '8px',
		'& .MuiFormControlLabel-label': {
			fontSize: '1rem',
			fontWeight: 400,
			textAlign: 'left',
			pl: '0.5rem',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
			color: isDark ? '#FFFFFF' : '#111111',
		},
	},
	radio: {
		color: isDark ? '#757575' : '#d0d0d0',
	},
	selectedRowBg: isDark ? '#2D2D2D' : '#F5F5F5',
});

export default getSelectLangStyles;
